import { createGetRequest } from '_helpers';

export async function appConfig() {
    return createGetRequest("app_config")
        .then(res => res.data)
        .then(({ success, data, successMsg, errorMsg }) => {
            return { response: success, data, successMsg, errorMsg };
        })
}